import React, { useState } from 'react';
import { Snackbar, Alert, Button, CircularProgress, Backdrop, Stack, Typography, Chip } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router';
import { LeegalityAgreementApi, LeegalityCheckStatusapi } from 'API/Services';

export default function PaymentTable(props) {
  const navigate = useNavigate();
  const DataTable = props.ResData;

  // date conversion
  function formatDateTime(dateString) {
    const date = new Date(dateString);

    // Get the day, month, and year
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    // Format date as DD-MM-YYYY
    const formattedDate = `${day}-${month}-${year}`;

    return `${formattedDate}`;
  }
  const userType = sessionStorage.getItem('UserType');

  const [OpenAlert, setOpenAlert] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [Err, setErr] = useState(false);
  const [ClickAgreement, setClickAgreement] = useState(false);
  const [ErrAgreement, setErrAgreement] = useState(false);
  const [AgreementValidate, setAgreementValidate] = useState(false);
  const [Isloading, setIsloading] = useState(false);

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setSuccess(false);
    setErr(false);
    setErrAgreement(false);
    setClickAgreement(false);
    setAgreementValidate(false);
    setLeegalityErr(false);
    setleegSuccess(false);
  };

  // leegality
  const LeegalityAgreement = (userId, productId, cspCode) => {
    LeegalityAgreementApi(userId, productId, cspCode, setClickAgreement, setErrAgreement, setIsloading, props.handleReFetch);
  };

  const [LeegalityTrue, setLeegalityTrue] = useState(false);
  const [LeegalityErr, setLeegalityErr] = useState(false);
  const [leegSuccess, setleegSuccess] = useState(false);
  // const[activeId,setActiveId]=useState(null)
  console.log('LeegalityTrue', LeegalityTrue);

  const LeegalityCheckStatus = (id, code) => {
    LeegalityCheckStatusapi(setIsloading, id, code, setleegSuccess, handleLeegalitySucess, setLeegalityErr, props.handleReFetch);
    // setActiveId(id)
  };

  const handleLeegalitySucess = () => {
    setLeegalityTrue(true);
  };

  return (
    <div>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={leegSuccess}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="success" variant="filled" sx={{ width: '100%' }}>
          {leegSuccess}
        </Alert>
      </Snackbar>
      <Snackbar open={OpenAlert} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          Something went wrong
        </Alert>
      </Snackbar>
      <Snackbar
        open={LeegalityErr}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          {LeegalityErr}
        </Alert>
      </Snackbar>
      <Snackbar
        open={AgreementValidate}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          Agreement signed process is pending
        </Alert>
      </Snackbar>
      <Snackbar open={Success} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="success" variant="filled" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <Snackbar open={Err} anchorOrigin={{ horizontal: 'right', vertical: 'top' }} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Err}
        </Alert>
      </Snackbar>
      <Snackbar
        open={ClickAgreement}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="success" variant="filled" sx={{ width: '100%' }}>
          {ClickAgreement}
        </Alert>
      </Snackbar>
      <Snackbar
        open={ErrAgreement}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity="error" variant="filled" sx={{ width: '100%' }}>
          {ErrAgreement}
        </Alert>
      </Snackbar>
      {/* <ImageModal open={OpenImage} handleClose={handleImageClose} image={ImageFile} /> */}
      {DataTable && DataTable.length ? (
        <Paper sx={{ width: '100%' }}>
          <TableContainer sx={{ maxHeight: 500, width: 1400 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 120, position: 'sticky', color: '#592375' }}>Agent Name</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>Agent Code</TableCell>
                  {/* <TableCell sx={{ width: 100 }}>Mobile No.</TableCell> */}
                  {/* <TableCell sx={{ width: 80 }}>District</TableCell> */}
                  {/* <TableCell sx={{ width: 80 }}>DS Name</TableCell> */}
                  {/* <TableCell sx={{ width: 80 }}>TM Name</TableCell> */}
                  <TableCell sx={{ width: 100, color: '#592375' }}>Bank Name</TableCell>
                  <TableCell sx={{ width: 100, color: '#592375' }}>CSP Code Creation Date</TableCell>
                  <TableCell sx={{ width: 100, color: '#592375' }}>CSP Code</TableCell>
                  <TableCell sx={{ width: 100, color: '#592375' }}>CSP Type</TableCell>
                  <TableCell sx={{ width: 80, color: '#592375' }}>CSP Status</TableCell>
                  {userType === 'ft' ? null : (
                    <>
                      {' '}
                      <TableCell sx={{ width: 120, color: '#592375' }}>E-Agreement</TableCell>
                      <TableCell sx={{ width: 120, color: '#592375' }}>Agreement Status</TableCell>
                    </>
                  )}
                  <TableCell sx={{ width: 120, color: '#592375' }}>Action</TableCell>
                  {/* <TableCell sx={{width:130}}>Resend Link</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {DataTable &&
                  DataTable
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                          <TableCell sx={{ width: 150 }}>{row.agent_name}</TableCell>
                          <TableCell>{row.agent_code}</TableCell>
                          {/* <TableCell sx={{ alignItems: 'center' }}>{row.user_data.mobile_number}</TableCell> */}
                          {/* <TableCell>{row.user_data.district}</TableCell> */}
                          {/* <TableCell>8974561232</TableCell>
                <TableCell>donald</TableCell>
                <TableCell>jake</TableCell> */}
                          <TableCell>{row.bank_name ? row.bank_name : '-'}</TableCell>
                          <TableCell x={{ textAlign: 'center' }}>
                            {row.csp_code_creation_date ? formatDateTime(row.csp_code_creation_date) : '-'}
                          </TableCell>
                          <TableCell sx={{ alignItems: 'center' }}>{row.csp_code ? row.csp_code : '-'}</TableCell>
                          <TableCell>{row.csp_type ? row.csp_type : '-'}</TableCell>
                          <TableCell>
                            {' '}
                            <Chip color="info" label={row.csp_code_status ? row.csp_code_status : 'Action required'} size="small" />{' '}
                          </TableCell>
                          {userType === 'ft' ? null : (
                            <>
                              <TableCell sx={{ alignItems: 'center' }}>
                                {row.csp_agreement_admin_link_expiry ? (
                                  <Button
                                    size="small"
                                    sx={{ textAlign: 'left' }}
                                    color="secondary"
                                    onClick={() => LeegalityAgreement(row.user_id, row.product_id, row.csp_code)}
                                  >
                                    Resend Link
                                  </Button>
                                ) : row.csp_agreement_details && row.csp_agreement_details.documentID ? (
                                  <Button
                                    size="small"
                                    sx={{ textAlign: 'left' }}
                                    color="secondary"
                                    disabled={row.csp_agreement_status || row.csp_agreement_agent_status}
                                    onClick={() => LeegalityAgreement(row.user_id, row.product_id, row.csp_code)}
                                  >
                                    Resend Link
                                  </Button>
                                ) : (
                                  <Button
                                    sx={{ textAlign: 'left' }}
                                    size="small"
                                    color="secondary"
                                    onClick={() => LeegalityAgreement(row.user_id, row.product_id, row.csp_code)}
                                  >
                                    Click to E-Agreement
                                  </Button>
                                )}
                              </TableCell>
                              <TableCell>
                                {row.csp_agreement_status ? (
                                  <Button
                                    size="small"
                                    color={row.csp_agreement_status ? 'success' : 'secondary'}
                                    // disabled={row.csp_agreement_status}
                                  >
                                    E-sign done
                                  </Button>
                                ) : (
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => LeegalityCheckStatus(row._id, row.csp_code)}
                                  >
                                    Check
                                  </Button>
                                )}
                              </TableCell>
                            </>
                          )}
                          <TableCell sx={{ cursor: 'pointer', alignItems: 'center' }}>
                            {row.csp_agreement_status ? (
                              <Button
                                sx={{
                                  marginRight: '5px'
                                  //  color: '#2196f3'
                                }}
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  navigate('/Admin/Code_Activation_Details', {
                                    state: {
                                      code: row.agent_code,
                                      name: row.agent_name,
                                      id: row._id,
                                      bank: row.bank_name,
                                      cspcode: row.csp_code,
                                      csptype: row.csp_type,
                                      cspstatus: row.csp_status,
                                      codecreatedate: row.csp_code_creation_date,
                                      // setValue: props.setValue,
                                      // for activation
                                      // userId:row.user_id,
                                      finvestausersproductid: row._id,
                                      productid: row.product_id
                                    }
                                  });
                                  // } else {
                                  //   LeegalityCheckStatus(row._id, row.csp_code);
                                  // }
                                }}
                              >
                                Activate
                              </Button>
                            ) : (
                              <Button size="small" onClick={() => LeegalityCheckStatus(row._id, row.csp_code)} color="secondary">
                                Activate
                              </Button>
                            )}
                            {/* <PanoramaIcon

                          sx={{ marginRight: '5px', color: '#9c27b0' }}
                          onClick={() => handleFileView(row.first_transaction_document_link)}
                        />
                        <DeleteIcon sx={{ color: '#f44336' }} onClick={() => handleDelete(row._id, row.csp_code)} /> */}
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            sx={{ width: '100%' }}
            rowsPerPageOptions={[10, 50, 100]}
            component="div"
            count={props.TotalCount}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={props.handleChangePage}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <Stack justifyContent="center" alignItems="center">
          {/* <CircularProgress /> */}
          <Typography mt={1} variant="h5">
            No data found
          </Typography>
        </Stack>
      )}
    </div>
  );
}
